<script>
import { defineComponent } from "vue";
import PasswordValidate from '@/helpers/passwordValidate';
import UserSrv from '@/services/user.service';
import { useMeta } from 'quasar';

const metaData = {
  // sets document title
  title: 'Windy City Wire - Account Settings',
  // optional; sets final title as "Index Page - My Website", useful for multiple level meta
  titleTemplate: title => `${title}`,
}

export default defineComponent({
    name: 'accountLanding',
    setup() {
		useMeta(metaData);
	},
	data() {
		return {
			p: "",
			np: "",
			visible: false,
			cell: ""
		}
	},
	methods: {
		resetForm() {
			this.p="";
			this.np=""
		},
		submitForm() {
			var self = this;
			this.visible = true;
			UserSrv.ChangePassword(this.user.accessToken, this.p).then((response) => {

				if (response.status == 200) {
					self.visible=false;
					
					// handle error
					if (response.data.error != null && response.data.error.length > 0) {
						self.$store.dispatch('message/sendMessage', {message: `Error Resetting Password: ${response.data.error}`, type: 'negative', position: 'bottom', icon: 'lock'}, {root:true});
						return;
					}

					self.$store.commit('auth/setUser', response.data.user);
					self.$store.commit('auth/setToken', response.data.user.accessToken);
					localStorage.setItem('user', JSON.stringify(response.data.user));
					self.$store.dispatch('message/sendMessage', {message: 'Password Was Successfully Updated', type: 'positive', position: 'bottom', icon: 'lock'}, {root:true});
					self.resetForm()
				}

			}).catch((e) => {
				self.$store.dispatch('message/sendMessage', {message: `Error Resetting Password: ${e}`, type: 'negative', position: 'bottom', icon: 'lock'}, {root:true});
				self.visible = false;
			})
		},
		saveMobile() {
			this.$store.dispatch('auth/saveUserMobile', [this.user.accessToken, this.cell])
		}
	},
	computed: {
		isValid() {
			return (PasswordValidate.CheckPassword(this.p) && this.p == this.np ? true : false)
		},
		user() {
			return this.$store.getters['auth/user'];
		},
		mobile() {
			return this.$store.getters['auth/mobile'];
		},
		isVerified() {
			return this.$store.getters['auth/mobileIsVerified'];
		}
	},
	mounted() {
		this.mobile != null && this.mobile.length > 0 ? this.cell = this.mobile : null;
	}
});
</script>

<template>
  <q-layout>
    <q-page-container>
      <q-page v-if="user!=null">
			<div class="bodyContainer mt-3">
				<div class="row">
					<div class="col-sm-12 q-pt-md">
						<h6 class="wcwH text-h6 q-mb-md">{{user.userName}}</h6>
						<h3 class="wcwH wcwGrey"><i>{{user.companyName}} (#{{user.customerNumber}})</i></h3>
					</div>
				</div>
				<div class="row">
					<div class="col-12 q-pt-md">
						<h4 class="wcwH wcwBlue strong">Update Password</h4>
						<p>In order to protect your account, make sure your password:</p>
						<ul class="q-mb-md" style="list-style-type: disc; padding-left: 40px">
							<li>Is longer than 8 characters</li>
							<li>Contains at least one number, one special character, and one uppercase letter</li>
						</ul>
						<div class="q-pa-sm">
							<q-input square filled v-model="p" label="New Password" type="password" color="cyan-7">
								<template v-slot:prepend>
									<q-icon name="lock" />
								</template>
							</q-input>
						</div>
						<div class="q-pa-sm">
							<q-input square filled v-model="np" label="Confirm Password" type="password" color="cyan-7">
								<template v-slot:prepend>
									<q-icon name="lock" />
								</template>
							</q-input>
						</div>
					</div>
				</div>
				<div class="row q-pt-md q-mb-md">
					<div class="col-12 text-center">
						<q-btn color="cyan-7" :ripple=true label="Update" :unelevated=true :disabled="!isValid" @click="submitForm()"/>
					</div>
				</div>
				<q-separator />
				<div class="row">
					<div class="col-12 q-pt-md">
						<h4 class="wcwH wcwBlue strong">Mobile Number (SMS)</h4>
						<p>Receive Account Verification codes via text message</p>
						<small class="text-negative strong" v-if="!isVerified && mobile!=null && mobile.length>0">Pending Mobile Number Verification</small>
						<div class="q-pa-sm">
							<q-input square filled v-model="cell" label="Phone #" type="text" color="cyan-7" mask="phone" clearable clear-icon="close">
								<template v-slot:prepend>
									<i class="fas fa-mobile-alt"></i>
								</template>
							</q-input>
							<q-btn push color="warning" label="Resend Code" class="q-mt-md" v-if="!isVerified && mobile.length>0 && (mobile==cell)" @click="$store.dispatch('auth/resendMobileCode', this.user.accessToken)"/>
						</div>
					</div>
				</div>
				<div class="row q-pt-md q-mb-md">
					<div class="col-12 text-center">
						<q-btn color="cyan-7" :ripple=true label="Save" :unelevated=true :disabled="mobile == cell" @click="saveMobile()" @clear="saveMobile()"/>
					</div>
				</div>
			</div>
			<q-inner-loading
				:showing="visible"
				label="Please wait loading data..."
				label-class="text-cyan-7"
				label-style="font-size: 1.5em"
				color="cyan-7"
			/>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<style scoped>
.mobileLink {}
</style>
